import Steps from './steps.vue';

export default Steps;